import { createAction } from "@ngrx/store";
import { FeatureStoreStateKey } from "src/controls/store-keys.enum";

export const ValidationError = createAction(`[${FeatureStoreStateKey.APP}] Validation error`, (error) => ({
	payload: error
}));